(ns frontend.ux-overhaul.page-components.navigation.subs
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::modal
 (fn [db _]
   (:modal-open? db)))


(rf/reg-sub
 ::active-nav
 (fn [db _]
   (:active-nav db)))

(rf/reg-sub
 ::show-all-pipelines?
 (fn [db _]
   (:show-all-pipelines? db)))

(rf/reg-sub
 ::show-all-favorites?
 (fn [db _]
   (:show-all-favorites? db)))

(rf/reg-sub
 ::show-all-webentries?
 (fn [db _]
   (:show-all-webentries? db)))

